
<div class="page-customized">
    <v-progress-linear
        v-if="overlay"
        absolute
        indeterminate
    ></v-progress-linear>

    <app-bar
        :title="athlete.exists() ? t('club_athlete_title_update') : t('club_athlete_title_create')"
        back="/club-athletes"
    />

    <v-layout class="mt-n8">
        <v-card
            width="100%"
            color="transparent"
            elevation="0"
            class="pb-8"
        >
            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_athlete_label_name') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="athlete.name"
                                type="text"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('name')"
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_athlete_label_title') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="athlete.title"
                                type="text"
                                outlined
                                dense
                                :error-messages="form.errors.get('title')"
                            ></v-text-field>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="athlete.title"
                                :items="athlete.translations['title']"
                                @touch="(v) => athlete.translations['title'] = v"
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_athlete_label_photo') }}</div>
                        <div class="horizontal-input">
                            <v-file-input
                                v-model="athlete.photo"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                :append-outer-icon="athlete.photoUrl ? 'mdi-eye-outline' : ''"
                                dense
                                :error-messages="photoForm.errors.get('photo')"
                                @click:append-outer="viewPhoto()"
                                @click:clear="athlete.photo = undefined"
                            ></v-file-input>
                        </div>
                    </div>
                    <div class="form-group-horizontal-cols">
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_athlete_label_gold_count') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="athlete.goldCount"
                                    type="number"
                                    step="1"
                                    min="0"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('gold_count')"
                                ></v-text-field>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_athlete_label_silver_count') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="athlete.silverCount"
                                    type="number"
                                    step="1"
                                    min="0"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('silver_count')"
                                ></v-text-field>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('club_athlete_label_bronze_count') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="athlete.bronzeCount"
                                    type="number"
                                    step="1"
                                    min="0"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('bronze_count')"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_athlete_label_status') }}</div>
                        <div class="horizontal-input">
                            <v-select
                                v-model="athlete.status"
                                :items="clubAthleteStatuses()"
                                outlined
                                append-icon="mdi-chevron-down"
                                dense
                                :error-messages="form.errors.get('status')"
                            ></v-select>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions class="px-4">
                <v-btn
                    :to="{ name: 'club-athletes' }"
                    class="mr-4"
                    color="primary"
                >{{ t('general_action_cancel') }}</v-btn>
                <v-btn
                    :loading="form.busy"
                    :disabled="form.busy"
                    color="orange"
                    @click.prevent="submit"
                >{{ athlete.exists() ? t('general_action_save') : t('club_athlete_title_create') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</div>
